import { Bird, TrendingUp, TrendingDown, BarChart3, Compass, type LucideIcon } from "lucide-react";

export interface AvatarPreset {
  id: string;
  label: string;
  Icon: LucideIcon;
  /** Tailwind classes for ring/text and background tint. */
  className: string;
}

export const AVATAR_PRESETS: AvatarPreset[] = [
  { id: "owl",     label: "Owl",     Icon: Bird,         className: "bg-accent/15 text-accent border-accent/40" },
  { id: "bull",    label: "Bull",    Icon: TrendingUp,   className: "bg-primary/15 text-primary border-primary/40" },
  { id: "bear",    label: "Bear",    Icon: TrendingDown, className: "bg-destructive/10 text-destructive border-destructive/40" },
  { id: "chart",   label: "Chart",   Icon: BarChart3,    className: "bg-secondary/60 text-foreground border-border" },
  { id: "compass", label: "Compass", Icon: Compass,      className: "bg-muted/40 text-muted-foreground border-border" },
];

export function getAvatarPreset(id?: string | null): AvatarPreset | null {
  if (!id) return null;
  return AVATAR_PRESETS.find((a) => a.id === id) ?? null;
}

export const FOUNDER_AVATAR_ID = "owl";